import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClInputFile } from '@corelabs/angular/ui';
import { ErrorComponent } from '../error/error.component';

@Component({
    selector: 'app-form-input-file',
    templateUrl: './form-input-file.component.html',
    styleUrls: ['./form-input-file.component.css'],
    imports: [ReactiveFormsModule, ClInputFile, ErrorComponent],
})
export class FormInputFileComponent {
    readonly control = input.required<FormControl<File | null>>();
    readonly label = input.required<string>();
    readonly inputId = input.required<string>();
    readonly accept = input<string>('');
}
